import { useTranslation } from 'react-i18next';
import BrandMark from '../../BrandMark/BrandMark';
import PillLink from '../../ui/PillLink/PillLink';
import Section from '../../ui/Section/Section';
import { useLanguage } from '../../../i18n/useLanguage';
import styles from './AboutSection.module.css';

export default function AboutSection() {
    const { t } = useTranslation();
    const { localizedPath } = useLanguage();

    return (
        <Section theme="dark" id="about" labelledBy="about-title">
            <div className={`page-inner ${styles.inner}`}>
                <h2 id="about-title" className="visually-hidden">{t('home.about.title')}</h2>
                <BrandMark variant="signet" className={styles.signet} />
                <p className={styles.statement}>{t('home.about.statement')}</p>
                <p className={styles.note}>{t('home.about.note')}</p>
                <div>
                    <PillLink href={localizedPath('/about')} variant="outline" icon="arrowRight">{t('home.about.action')}</PillLink>
                </div>
            </div>
        </Section>
    );
}
